import Vue from 'vue'
import axios from '@/wrappers/axios.js'

const MeetingService = {

    meetingList(params) {
        return new Promise(async (resolve, reject) => {
            axios
                .get(`/meetings${params ? params : ''}`)
                .then(response => {
                    resolve(response.data)
                })
                .catch(e => reject(e));
        })
    },

    createMeeting(data) {
        return new Promise(async (resolve, reject) => {
            axios
                .post(`/meetings`, data)
                .then(response => {
                    resolve(response.data)
                })
                .catch(e => reject(e));
        })
    },

    getMeeting(id, params) {
        return new Promise(async (resolve, reject) => {
            axios
                .get(`/meetings/${id}${params ? params : ''}`)
                .then(response => {
                    resolve(response.data)
                })
                .catch(e => reject(e));
        })
    },

    updateMeeting(id, data) {
        return new Promise(async (resolve, reject) => {
            axios
                .put(`/meetings/${id}`, data)
                .then(response => {
                    resolve(response.data)
                })
                .catch(e => reject(e));
        })
    },
    delete(id) {
        return new Promise(async (resolve, reject) => {
            axios
                .delete(`/meetings/${id}`)
                .then(response => {
                    resolve(response.data)
                })
                .catch(e => reject(e));
        })
    }
}

Vue.$meetingService = MeetingService

export default MeetingService